import {
  Box,
  Button,
  Modal as CSDModal,
  SpaceBetween,
} from "@cloudscape-design/components-themed";

import { LABELS } from "./constants";

interface Props {
  children?: React.ReactNode;
  visible: boolean;
  title?: string;
  negativeBtnLabel?: string;
  positiveBtnLabel?: string;
  positiveFn: Function;
  setVisibleFn: Function;
}

/*
 * モーダル内容をpropsとして渡すモーダル
 */
const FlexibleModal = ({
  children,
  visible,
  title = LABELS.TITLE,
  positiveBtnLabel = LABELS.OK,
  negativeBtnLabel = LABELS.CANCEL,
  positiveFn,
  setVisibleFn,
}: Props) => {
  /**
   * ポジティブボタンを押下するイベント関数
   */
  const onClickPositiveBtnHandler = () => {
    positiveFn();
    setVisibleFn(false);
  };

  /**
   * モーダルクローズ関数
   * @returns void
   */
  const onDismissHandler = () => setVisibleFn(false);

  return (
    <CSDModal
      visible={visible}
      onDismiss={onDismissHandler}
      closeAriaLabel="Close modal"
      size="large"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xxl">
            <Button variant="link" onClick={onDismissHandler}>
              {negativeBtnLabel}
            </Button>
            <Button variant="primary" onClick={onClickPositiveBtnHandler}>
              {positiveBtnLabel}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={title}
    >
      {children}
    </CSDModal>
  );
};

export default FlexibleModal;
